import type { OrderStatus } from "@/lib/api/types";
import type { SellerOrderStatusStyle } from "./order-list.types";

export const ORDERS_CURRENCY_CODE = "EGP";

export const statusStyleMap: Record<OrderStatus, SellerOrderStatusStyle> = {
  draft: {
    badgeClass:
      "border-border bg-field text-text",
    dotClass: "bg-muted",
  },
  pending_buyer_verification: {
    badgeClass:
      "border-warning/35 bg-warning/8 text-text",
    dotClass: "bg-warning",
  },
  pending_buyer_payment: {
    badgeClass:
      "border-warning/35 bg-warning/8 text-text",
    dotClass: "bg-warning",
  },
  pending_payment_verification: {
    badgeClass:
      "border-warning/35 bg-warning/8 text-text",
    dotClass: "bg-warning",
  },
  paid_less_than_required: {
    badgeClass:
      "border-warning/35 bg-warning/8 text-text",
    dotClass: "bg-warning",
  },
  confirmed: {
    badgeClass:
      "border-success/30 bg-success/8 text-text",
    dotClass: "bg-success",
  },
  preparing: {
    badgeClass:
      "border-brand/25 bg-brand/10 text-brand-hover",
    dotClass: "bg-brand",
  },
  shipped: {
    badgeClass:
      "border-brand/25 bg-brand/10 text-brand-hover",
    dotClass: "bg-brand",
  },
  delivered: {
    badgeClass:
      "border-success/30 bg-success/8 text-text",
    dotClass: "bg-success",
  },
  declined: {
    badgeClass:
      "border-danger/30 bg-danger/10 text-danger",
    dotClass: "bg-danger",
  },
  cancelled: {
    badgeClass:
      "border-danger/30 bg-danger/10 text-danger",
    dotClass: "bg-danger",
  },
};
